// extracted by mini-css-extract-plugin
export default {"root":"InfoBlock_root__9haTK","info":"InfoBlock_info__v0I7i","warning":"InfoBlock_warning__Edja0"};